import React, { lazy } from "react";
import { Route } from "react-router-dom";
import InventoryRouteFallback from "../../pages/Inventory/components/InventoryRouteFallback";
import { InventoryModuleStatusProvider } from "../../pages/Inventory/context/InventoryModuleStatusContext";
import RouteSuspense from "../RouteSuspense";

const InventoryIndexRoute = lazy(() =>
  import("../../pages/Inventory/components/InventoryIndexRoute")
);
const DailyStock = lazy(() => import("../../pages/Inventory/DailyStock"));
const InventoryRestock = lazy(() => import("../../pages/Inventory/InventoryRestock"));
const InventoryArchive = lazy(() => import("../../pages/Inventory/InventoryArchive"));
const InventoryHistory = lazy(() => import("../../pages/Inventory/InventoryHistory"));
const MenuCreation = lazy(() => import("../../pages/menucreation/MenuCreation"));
const MenuArchive = lazy(() => import("../../pages/menucreation/MenuArchive"));
const Views = lazy(() => import("../../pages/views/Views"));
const KitchenView = lazy(() => import("../../pages/views/KitchenView"));
const FrontOfDeskView = lazy(() => import("../../pages/views/FrontOfDeskView"));
const TableManagementView = lazy(() => import("../../pages/views/TableManagementView"));
const ClaimingView = lazy(() => import("../../pages/views/ClaimingView"));

const RestaurantLiveRoutes = () => (
  <>
    <Route
      path="/inventory"
      element={<InventoryModuleStatusProvider />}
    >
      <Route
        index
        element={
          <RouteSuspense fallback={<InventoryRouteFallback />}>
            <InventoryIndexRoute />
          </RouteSuspense>
        }
      />
      <Route
        path="daily-stock"
        element={
          <RouteSuspense fallback={<InventoryRouteFallback />}>
            <DailyStock />
          </RouteSuspense>
        }
      />
      <Route
        path="restock"
        element={
          <RouteSuspense fallback={<InventoryRouteFallback />}>
            <InventoryRestock />
          </RouteSuspense>
        }
      />
      <Route
        path="archive"
        element={
          <RouteSuspense fallback={<InventoryRouteFallback />}>
            <InventoryArchive />
          </RouteSuspense>
        }
      />
      <Route
        path="history"
        element={
          <RouteSuspense fallback={<InventoryRouteFallback />}>
            <InventoryHistory />
          </RouteSuspense>
        }
      />
    </Route>
    <Route path="/menucreation" element={<RouteSuspense><MenuCreation /></RouteSuspense>} />
    <Route path="/menucreation/archived" element={<RouteSuspense><MenuArchive /></RouteSuspense>} />
    <Route path="/views" element={<RouteSuspense><Views /></RouteSuspense>} />
    <Route path="/views/kitchen" element={<RouteSuspense><KitchenView /></RouteSuspense>} />
    <Route path="/views/front" element={<RouteSuspense><FrontOfDeskView /></RouteSuspense>} />
    <Route path="/views/tables" element={<RouteSuspense><TableManagementView /></RouteSuspense>} />
    <Route path="/views/claiming" element={<RouteSuspense><ClaimingView /></RouteSuspense>} />
  </>
);

export default RestaurantLiveRoutes;
